import { SHOW_HIDE_SNACKBAR } from "./types";

export const showHideSnackbar = (payload) => ({
  type: SHOW_HIDE_SNACKBAR,
  payload
});
